import createServiceAsyncThunk from "../../../utils/reduxUtils/createServiceAsyncThunk";
import createGenericSlice from "../../../utils/reduxUtils/createEntitySlice";
import { userService } from "../../../Api/Services/UserService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../constants/action";
import { ERROR_MESSAGES } from "../../../constants/error";
import {
  IBaseResponse,
  IChangePasswordPayload,
} from "../../../Types/UserProfileDetails";

// Async thunk for changing password
export const employeeChangePasswordThunk = createServiceAsyncThunk<
  IBaseResponse,
  { id: number | string; passwordPayload: IChangePasswordPayload }
>(
  ACTION_NAMES.EMPLOYEE_CHANGE_PASSWORD,
  (payload) => userService.changePassword(payload.id, payload.passwordPayload),
  ERROR_MESSAGES.EMPLOYEE_CHANGE_PASSWORD_FAILURE
);

// Slice
export const employeeChangePasswordSlice = createGenericSlice<
  IBaseResponse,
  { id: number | string; passwordPayload: IChangePasswordPayload }
>(SLICE_NAMES.EMPLOYEE_CHANGE_PASSWORD_SLICE, employeeChangePasswordThunk);

// Export actions
export const {
  clearError: clearEmployeeChangePasswordError,
  clearSuccessMessage: clearEmployeeChangePasswordSuccess,
} = employeeChangePasswordSlice.actions;

export default employeeChangePasswordSlice.reducer;
